import { useLocale } from './LocaleProvider';
import { translateCopy, translateTree } from './Localize';
import pt from './catalogs/shared/pt-BR.json';
import { useToast } from '@/hooks/use-toast';
import type { ZodIssue } from 'zod';

type SharedMessages = { [K in keyof typeof pt]: string };
export const sharedCatalog: { en: SharedMessages; 'pt-BR': SharedMessages } = {
  en: Object.fromEntries(Object.keys(pt).map(key => [key, key])) as SharedMessages,
  'pt-BR': pt,
};
export { pt as sharedPortuguese };
export function useSharedCopy() {
  const { locale } = useLocale();
  const messages = sharedCatalog[locale];
  return { t: (value: string) => translateCopy(value, messages), tree: (node: React.ReactNode) => translateTree(node, messages, locale) };
}
export function useLocalizedToast() {
  const original = useToast();
  const { t } = useSharedCopy();
  return { ...original, toast: (props: Parameters<typeof original.toast>[0]) => original.toast({
    ...props,
    ...(typeof props.title === 'string' ? { title: t(props.title) } : {}),
    ...(typeof props.description === 'string' ? { description: t(props.description) } : {}),
  }) };
}

export function useValidationMessage() {
  const { locale, formatLocale } = useLocale();
  const { t } = useSharedCopy();
  return (issue: ZodIssue): string => {
    const translated = t(issue.message);
    if (locale === 'en' || translated !== issue.message) return translated;
    if (issue.code === 'too_big') return `Use no máximo ${new Intl.NumberFormat(formatLocale).format(Number(issue.maximum))} caracteres.`;
    if (issue.code === 'too_small') return `Use pelo menos ${new Intl.NumberFormat(formatLocale).format(Number(issue.minimum))} caracteres.`;
    return 'Confira os dados informados e tente novamente.';
  };
}
